define('controllers/Podio.Controllers.SpaceSwitcher',['require','underscore','views/space_switcher/Podio.Views.SpaceSwitcher','lib/backbone/Backbone.PodioModel','models/Podio.Models.Organization','collections/Podio.Collections.Organizations','lib/backbone/Backbone.PodioCollection','controllers/leftnav/Podio.Controllers.LeftNav.Main','lib/backbone/Backbone.PodioController','lib/Podio.Config','lib/Podio.Routes','lib/Podio.Utils.Text','lib/Podio.Utils','lib/Podio.Store','lib/backbone/Backbone.Mixins.Transport.API'],function(require) {

  var _ = require('underscore');
  var SpaceSwitcherView = require('views/space_switcher/Podio.Views.SpaceSwitcher');

  var PodioModel = require('lib/backbone/Backbone.PodioModel');
  var OrganizationModel = require('models/Podio.Models.Organization');
  var OrganizationsCollection = require('collections/Podio.Collections.Organizations');
  var PodioCollection = require('lib/backbone/Backbone.PodioCollection');

  var LeftNavController = require('controllers/leftnav/Podio.Controllers.LeftNav.Main');

  var PodioController = require('lib/backbone/Backbone.PodioController');
  var podioConfig = require('lib/Podio.Config');
  var routes = require('lib/Podio.Routes');
  var textUtils = require('lib/Podio.Utils.Text');
  var utils = require('lib/Podio.Utils');
  var podioStore = require('lib/Podio.Store');

  var API = require('lib/backbone/Backbone.Mixins.Transport.API');

  return PodioController.extend({

    initialize: function() {
      this._super();
      this.bindEvents();

      this.searchResultCollection = new PodioCollection();

      this.dfdOrganizationData = API.request('GET', '/org/');
      this.initStore();
    },

    bindEvents: function() {
      this.eventBus.bind('SpaceSwitcher:show', this.onSpaceSwitcherShow, this);
      this.eventBus.bind('SpaceSwitcher:search', this.onSearchChanged, this);
    },

    initStore: function() {
      var dataStoreName = 'navigation';
      this.dataStore = podioStore.get(dataStoreName) || podioStore.create(dataStoreName, true);
    },

    onSpaceSwitcherShow: function() {
      this.dfdOrganizationData.done(function(data) {

        if (_.isUndefined(this.organizations) && _.isUndefined(this.currentOrganization)) {
          this.organizations = new OrganizationsCollection(data.map(function(org) {
            org['id'] = org.org_id;

            org.spaces.map(function(space) {
              space['id'] = space.space_id;

              return space;
            });

            return org;
          }));
          this.currentOrganization = podioConfig.current_org_id ? this.organizations.get(podioConfig.current_org_id) : new OrganizationModel();
        }

        if (!this.leftNavController) {
          this.leftNavController = new LeftNavController({
            organizations: this.organizations,
            currentOrganization: this.currentOrganization
          });
        }

      }.bind(this));
    },

    hideSpaceSwitcher: function() {
      if (this.spaceSwitcher) {
        this.spaceSwitcher.dispose();
      }
    },

    showSpaceSwitcher: function() {
      if (!this.spaceSwitcher) {
        this.spaceSwitcher = new SpaceSwitcherView({
          eventBus: this.eventBus,
          elmContainer: this.getOption('elmContainer'),
          searchResultCollection: this.searchResultCollection
        });

        this.spaceSwitcher.render();
      }

      this.spaceSwitcher.show();
    },

    renderSearchResults: function(results) {
      this.searchResultCollection.reset(results);

      if (results.length) {
        this.spaceSwitcher.showSearchResultsContainer();
        this.spaceSwitcher.searchResult.highlightFirst();
      }
      else {
        this.spaceSwitcher.showBlankSlate();
      }
    },

    onSearchChanged: function(query) {
      this.loadNavResults(query);
    },

    loadNavResults: _.debounce(function(query) {
      if (this.currentNavDfd) {
        this.currentNavDfd.abort();
        delete this.currentNavDfd;
      }

      if (!query.length) {
        this.searchResultCollection.reset();
        this.spaceSwitcher.showLeftNav();
        return;
      }

      var cachedResults = this.dataStore.get(query);
      if (!_.isUndefined(cachedResults)) {
        this.renderSearchResults(cachedResults);
      }

      var self = this;

      var requestData = {
        target: 'navigation',
        text: query,
        limit: 30
      };

      this.currentNavDfd = API.request('post', '/reference/search', requestData);
      this.currentNavDfd.done(function(responseData) {
        var results = [];
        if (responseData.length) {
          results = _.map(responseData[0].contents, self.resultToModel);
        }

        self.dataStore.store(query, results);

        self.renderSearchResults(results);
      });
    }, 100),

    resultToModel: function(result) {
      return new PodioModel({
        id: '{0}_{1}'.format(result.type, result.id),
        type: result.type,
        name: result.title,
        url: result.link,
        url_add: result.link_add,
        item_name: result.item_name,
        app_icon: result.app_icon,
        space_name: result.space_name,
        org_name: result.org_name
      });
    }
  });
});





